<template>
  <div>
    <v-sheet class="transparent-background-color">
      <!-- <v-card class="page-card"> -->
      <v-card class="ma-3">
        <v-card-title class="mx-3">
          {{ $t("CRUD.editInfo", [$t("Recipes.ObjectName")]) }}
          <v-spacer></v-spacer>
          <v-row dense>
            <v-spacer></v-spacer>
            <v-col cols="2" class="me-1 mr-n4">
              <v-btn
                outlined
                color="secondary"
                @click="
                  $emit('input', null);
                  $emit('mode', null);
                  $emit('save');
                  costCardInfo = [];
                  foodFormulaInfo = [];
                  materialIdsArr = [];
                  formulaIdsArr = [];
                "
                small
              >
                <v-icon small class="pe-1">fa-times</v-icon>
                {{ $t("CRUD.back") }}
              </v-btn>
            </v-col>
            <v-col cols="2" class="me-1">
              <v-btn
                color="success"
                :disabled="loading && !recipe.id"
                @click="submit()"
                small
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.save") }}
              </v-btn>
            </v-col>
          </v-row>
          <!-- <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Recipes.ObjectName")]) }}
            </span>
          </v-tooltip> -->
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-row align="center">
            <v-col cols="2" class="font-weight-bold text-left ml-3">
              {{ $t("Recipes.Fields.recipe_code") + $t("Global.colon") }}
            </v-col>
            <v-col cols="9" md="7" class="ml-n12">
              {{ recipe.formula_code }}
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="2" class="font-weight-bold text-left ml-3">
              {{ $t("Recipes.Fields.recipe_name") + $t("Global.colon") }}
            </v-col>
            <v-col cols="9" md="7" class="ml-n12">
              {{ recipe.formula_name }}
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="2" class="font-weight-bold text-left ml-3">
              {{ $t("Recipes.Fields.binded_cuisine") + $t("Global.colon") }}
            </v-col>
            <v-col cols="9" md="7" class="ml-n12">
              <v-chip
                v-for="dish in dishes"
                :key="dish.food_id"
                class="mr-2"
                color="primary"
                outlined
                label
                @click.stop="
                  $permission.checkAccountExpired().then(() => {
                    $router.push({
                      path: '/dishes?id=' + dish.food_id,
                      query: { mode: 'view' },
                    });
                  })
                "
              >
                {{ dish.food.food_code + " / " + dish.food.food_name }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="2" class="font-weight-bold text-left ml-3">
              {{ $t("Recipes.Fields.other_cost") + $t("Global.colon") }}
            </v-col>
            <v-col cols="9" md="7" class="ml-n12">
              <v-text-field
                single-line
                v-model="recipe.other_cost"
                type="number"
                min="0"
                @blur="
                  recipe.other_cost = $numberFormatter.formatMoney(
                    recipe.other_cost
                  )
                "
                :prefix="$t('Global.money')"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="2" class="font-weight-bold text-left ml-3">
              {{ $t("Recipes.Fields.recipe_setting") + $t("Global.colon") }}
            </v-col>
            <v-col cols="9" md="7" class="ml-n12">
              <!-- <v-btn
                v-if="!editCostCardBtn"
                small
                color="primary"
                @click.stop="editCostCardBtn = true"
                class="ms-1"
              >
                {{ $t("Recipes.Fields.cost_card_setting") }}
              </v-btn>
              <div v-if="editCostCardBtn" class="ms-0"> -->
              <div class="ms-0">
                <v-btn
                  v-if="!recipe.bom_no_modify"
                  small
                  color="primary"
                  @click.stop="selectMaterialsDialog = true"
                  class="mb-2"
                  outlined
                >
                  {{ $t("Recipes.Fields.add_material") }}
                </v-btn>
                <!-- <br v-if="!recipe.bom_no_modify" /> -->
                <!-- <v-data-table
                  :headers="header"
                  :items="costCardInfo"
                  :loading="loading"
                  multi-sort
                  class="elevation-1 px-4 pt-2 sticky-table sticky-first-col"
                  id="sticky-table"
                  fixed-header
                  disable-pagination
                  hide-default-footer
                >
                  <template v-slot:header.actions="{ header }">
                    {{ header.text }}
                    <v-icon x-small>fa-sliders-h</v-icon>
                  </template>
                  <template v-slot:item.material.cost_unit_rate="{ item }">
                    {{ item.material.cost_unit_rate }}
                  </template>
                  <template v-slot:item.net_weight="{ item }">
                    <v-text-field
                      v-if="!recipe.bom_no_modify"
                      single-line
                      v-model="item.net_weight"
                      type="number"
                      min="0"
                      :suffix="item.material.cost_unit"
                      @input="getNetRate(item)"
                    />
                    <span v-else>
                      {{ item.net_weight }}
                      {{ item.material.cost_unit }}
                    </span>
                  </template>
                  <template v-slot:item.gross_weight="{ item }">
                    <v-text-field
                      v-if="!recipe.bom_no_modify"
                      single-line
                      v-model="item.gross_weight"
                      type="number"
                      min="0"
                      :suffix="item.material.cost_unit"
                      @input="getNetRate(item)"
                    />
                    <span v-else>
                      {{ item.gross_weight }}
                      {{ item.material.cost_unit }}
                    </span>
                  </template>
                  <template v-slot:item.net_rate="{ item }">
                    {{ item.net_rate | formatTwoDot }}
                    {{ $t("Global.rate") }}
                  </template>
                  <template v-slot:item.major_ingredient_flg="{ item }">
                    <v-radio-group
                      v-if="!recipe.bom_no_modify"
                      row
                      v-model="item.major_ingredient_flg"
                      dense
                      small
                    >
                      <v-radio
                        :label="$t('Recipes.Fields.main_ingredient')"
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('Recipes.Fields.ingredients')"
                        :key="2"
                        :value="2"
                      />
                    </v-radio-group>
                    <span v-else>
                      <v-chip
                        small
                        label
                        dark
                        :color="item.major_ingredient_flg ? 'primary' : 'grey'"
                      >
                        {{
                          item.major_ingredient_flg
                            ? $t("Recipes.Fields.main_ingredient")
                            : $t("Recipes.Fields.ingredients")
                        }}
                      </v-chip>
                    </span>
                  </template>
                  <template v-slot:item.cost_flg="{ item }">
                    <div
                      class="d-flex mt-n2 mb-n3"
                      v-if="!recipe.bom_no_modify"
                    >
                      <v-checkbox
                        color="primary"
                        v-model="item.cost_flg"
                        :true-value="1"
                        :false-value="0"
                      >
                        <template v-slot:label>
                          <span class="caption ms-n2">
                            {{
                              $t(
                                item.cost_flg
                                  ? "Recipes.Fields.count_const_on"
                                  : "Recipes.Fields.count_const_off"
                              )
                            }}
                          </span>
                        </template>
                      </v-checkbox>
                    </div>
                    <span v-else>
                      <v-chip
                        small
                        label
                        dark
                        :color="item.cost_flg ? 'primary' : 'grey'"
                      >
                        {{
                          $t(
                            item.cost_flg
                              ? "Recipes.Fields.count_const_on"
                              : "Recipes.Fields.count_const_off"
                          )
                        }}
                      </v-chip>
                    </span>
                  </template>
                  <template
                    v-slot:item.replace_material.material_name="{ item }"
                  >
                    {{
                      item.replace_material
                        ? item.replace_material.material_name
                        : ""
                    }}
                    <br />
                    <v-btn
                      v-if="!recipe.bom_no_modify"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="
                        selectReplaceMaterialDialog = true;
                        currentItem = item;
                      "
                    >
                      {{ $t("CRUD.rechooseInfo", [$t("Material.ObjectName")]) }}
                    </v-btn>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      small
                      text
                      class="danger--text pa-0"
                      @click="
                        costCardInfo.splice(
                          costCardInfo.findIndex((info) =>
                            item.id
                              ? item.id == info.id
                              : item.material_id == info.material_id &&
                                item.new == info.new
                          ),
                          1
                        )
                      "
                    >
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </template>
                </v-data-table> -->
              </div>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-spacer></v-spacer>
            <v-col cols="11">
              <ValidationObserver ref="observer">
                <v-data-table
                  :headers="header"
                  :items="costCardInfo"
                  :loading="loading"
                  multi-sort
                  class="elevation-1 px-4 mt-n3"
                  fixed-header
                  disable-pagination
                  hide-default-footer
                >
                  <template v-slot:top>
                    <v-toolbar
                      flat
                      class="transparent-background-color"
                      align-self="end"
                    >
                      <v-spacer></v-spacer>
                      <span
                        class="text-no-wrap caption secondary--text"
                        :class="
                          $vuetify.theme.dark
                            ? 'text--lighten-1'
                            : 'text--darken-1'
                        "
                      >
                        {{ $t("Recipes.Fields.conversion_rate_describe") }}
                      </span>
                    </v-toolbar>
                  </template>
                  <template v-slot:header.actions="{ header }">
                    {{ header.text }}
                    <v-icon x-small>fa-sliders-h</v-icon>
                  </template>
                  <template v-slot:item.material.material_name="{ item }">
                    <div class="d-inline-block ma-1">
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="d-block text-truncate"
                            style="max-width: 430px; cursor: pointer"
                            >{{ item.material.material_name | ellipsis }}
                          </span>
                        </template>
                        {{ item.material.material_name }}
                      </v-tooltip>
                      <span class="caption secondary--text">
                        {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                        <span v-if="item.material && item.material.standard_name && item.material.standard_name.length > 12" :title="item.material.standard_name" style="cursor: pointer">
                          {{ item.material.standard_name.slice(0, 12) + "......" }}
                        </span>
                        <span v-else>
                          {{ item.material.standard_name }}
                        </span>
                      </span>
                    </div>
                  </template>
                  <template v-slot:item.material.cost_unit_rate="{ item }">
                    {{ item.material.cost_unit_rate }}
                  </template>
                  <template v-slot:item.net_weight="{ item }">
                    <ValidationProvider
                      v-if="!recipe.bom_no_modify"
                      :name="$t('Recipes.Fields.net_weight')"
                      v-slot="{ errors }"
                      rules="required|moreThan:0"
                    >
                      <v-text-field
                        single-line
                        v-model="item.net_weight"
                        type="number"
                        min="0"
                        :suffix="item.material.cost_unit"
                        :error-messages="errors"
                        @input="getNetRate(item)"
                      />
                    </ValidationProvider>
                    <span v-else>
                      {{ item.net_weight }}
                      {{ item.material.cost_unit }}
                    </span>
                  </template>
                  <template v-slot:item.gross_weight="{ item }">
                    <ValidationProvider
                      v-if="!recipe.bom_no_modify"
                      :name="$t('Recipes.Fields.gross_weight')"
                      v-slot="{ errors }"
                      rules="required|moreThan:0"
                    >
                      <v-text-field
                        single-line
                        v-model="item.gross_weight"
                        type="number"
                        min="0"
                        :suffix="item.material.cost_unit"
                        :error-messages="errors"
                        @input="getNetRate(item)"
                      />
                    </ValidationProvider>
                    <span v-else>
                      {{ item.gross_weight }}
                      {{ item.material.cost_unit }}
                    </span>
                  </template>
                  <template v-slot:item.net_rate="{ item }">
                    {{ item.net_rate | formatTwoDot }}
                    {{ $t("Global.rate") }}
                  </template>
                  <template v-slot:item.major_ingredient_flg="{ item }">
                    <v-radio-group
                      v-if="!recipe.bom_no_modify"
                      row
                      v-model="item.major_ingredient_flg"
                      dense
                      small
                    >
                      <v-radio
                        :label="$t('Recipes.Fields.main_ingredient')"
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('Recipes.Fields.ingredients')"
                        :key="2"
                        :value="2"
                      />
                    </v-radio-group>
                    <span v-else>
                      <v-chip
                        small
                        label
                        dark
                        :color="item.major_ingredient_flg ? 'primary' : 'grey'"
                      >
                        {{
                          item.major_ingredient_flg
                            ? $t("Recipes.Fields.main_ingredient")
                            : $t("Recipes.Fields.ingredients")
                        }}
                      </v-chip>
                    </span>
                  </template>
                  <template v-slot:item.cost_flg="{ item }">
                    <div
                      class="d-flex mt-n2 mb-n3"
                      v-if="!recipe.bom_no_modify"
                    >
                      <v-checkbox
                        color="primary"
                        v-model="item.cost_flg"
                        :true-value="1"
                        :false-value="0"
                      >
                        <template v-slot:label>
                          <span class="caption ms-n2">
                            {{
                              $t(
                                item.cost_flg
                                  ? "Recipes.Fields.count_const_on"
                                  : "Recipes.Fields.count_const_off"
                              )
                            }}
                          </span>
                        </template>
                      </v-checkbox>
                    </div>
                    <span v-else>
                      <v-chip
                        small
                        label
                        dark
                        :color="item.cost_flg ? 'primary' : 'grey'"
                      >
                        {{
                          $t(
                            item.cost_flg
                              ? "Recipes.Fields.count_const_on"
                              : "Recipes.Fields.count_const_off"
                          )
                        }}
                      </v-chip>
                    </span>
                  </template>
                  <template
                    v-slot:item.replace_material.material_name="{ item }"
                  >
                    {{
                      item.replace_material
                        ? item.replace_material.material_name
                        : ""
                    }}
                    <br />
                    <v-btn
                      v-if="!recipe.bom_no_modify"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="
                        selectReplaceMaterialDialog = true;
                        currentItem = item;
                      "
                    >
                      {{ $t("CRUD.rechooseInfo", [$t("Material.ObjectName")]) }}
                    </v-btn>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      small
                      text
                      class="danger--text pa-0"
                      @click="
                        costCardInfo.splice(
                          costCardInfo.findIndex((info) =>
                            item.id
                              ? item.id == info.id
                              : item.material_id == info.material_id &&
                                item.new == info.new
                          ),
                          1
                        )
                      "
                    >
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </ValidationObserver>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2" class="font-weight-bold text-left ml-3"></v-col>
            <v-col cols="9" md="7" class="ml-n12">
              <div class="ms-0">
                <v-btn
                  v-if="!recipe.bom_no_modify"
                  small
                  color="primary"
                  @click.stop="selectCostCardsDialog = true"
                  class="mb-2"
                  outlined
                >
                  {{ $t("Recipes.Fields.add_cost_card") }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-spacer></v-spacer>
            <v-col cols="11">
              <ValidationObserver ref="observer">
                <v-data-table
                  :headers="costCardHeader"
                  :items="foodFormulaInfo"
                  :loading="loading"
                  multi-sort
                  class="elevation-1 px-4 mt-n3"
                  fixed-header
                  disable-pagination
                  hide-default-footer
                >
                  <template v-slot:header.actions="{ header }">
                    {{ header.text }}
                    <v-icon x-small>fa-sliders-h</v-icon>
                  </template>
                  <template v-slot:item.food_formula.formula_name="{ item }">
                    <a
                      @click="
                        costCardMaterialsDialog = true;
                        currentFormulaId = item.formula_id;
                      "
                    >
                      {{ item.food_formula.formula_name }}
                    </a>
                  </template>
                  <template v-slot:item.with_num="{ item }">
                    <ValidationProvider
                      v-if="!recipe.bom_no_modify"
                      :name="$t('Recipes.Fields.with_num')"
                      v-slot="{ errors }"
                      rules="required|moreThan:0"
                    >
                      <v-text-field
                        single-line
                        v-model="item.with_num"
                        type="number"
                        min="0"
                        :error-messages="errors"
                        @blur="
                          item.with_num = $numberFormatter.formatTwoDot(
                            item.with_num,
                            true
                          )
                        "
                      />
                    </ValidationProvider>
                    <span v-else>
                      {{ item.with_num }}
                    </span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      small
                      text
                      class="danger--text pa-0"
                      @click="
                        foodFormulaInfo.splice(
                          foodFormulaInfo.findIndex(
                            (info) => item.formula_id == info.formula_id
                          ),
                          1
                        )
                      "
                    >
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </ValidationObserver>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                outlined
                color="secondary"
                class="elevation-1"
                block
                @click="
                  $emit('input', null);
                  $emit('mode', null);
                  $emit('save');
                "
              >
                <v-icon small class="pe-1">fa-times</v-icon>
                {{ $t("CRUD.backToList", [$t("Recipes.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn
                color="success"
                block
                :disabled="loading && !recipe.id"
                @click="submit()"
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.saveInfo", [$t("Recipes.ObjectName")]) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card> -->
    </v-sheet>

    <v-dialog v-model="selectReplaceMaterialDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          <SearcherMaterial
            v-model="selectReplaceMaterial"
            :disabledItems="currentItem ? [currentItem.material] : []"
            no-label
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <MaterialsSelectsDialog
      v-model="selectMaterialsDialog"
      :materialIds="materialIdsArr"
      :options="{ raw_material_flgs: [1] }"
      @confirm="addMaterials = $event"
    />
    <CostCardSelectsDialog
      v-model="selectCostCardsDialog"
      :costCardIds="formulaIdsArr"
      @confirm="addcostCards = $event"
    />
    <DialogCostCardMaterials
      v-model="costCardMaterialsDialog"
      :formulaId="currentFormulaId"
    />
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import MaterialsSelectsDialog from "@/components/plugins/MaterialsSelectsDialog";
import SearcherMaterial from "./SearcherMaterial";
import Recipes from "@/api/recipes";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import CostCardSelectsDialog from "./CostCardSelectsDialog";
import DialogCostCardMaterials from "./DialogCostCardMaterials";

export default {
  name: "RecipeDetail",

  props: ["value", "mode"],

  components: {
    SearcherMaterial,
    MaterialsSelectsDialog,
    ValidationObserver,
    ValidationProvider,
    CostCardSelectsDialog,
    DialogCostCardMaterials,
  },

  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 6) {
        return value.slice(0, 6) + "...";
      }
      return value;
    },
  },

  computed: {
    header() {
      var headers = [
        {
          text: i18n.t("Recipes.Fields.material_code"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "material.material_code",
        },
        {
          text: i18n.t("Recipes.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material.material_name",
        },
        // {
        //   text: i18n.t("Recipes.Fields.standard_name"),
        //   align: "start",
        //   class: "text-no-wrap",
        //   sortable: false,
        //   value: "material.standard_name",
        // },
        {
          text: i18n.t("Recipes.Fields.default_unit"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "material.standard.default_standard_detail.unit",
        },
        {
          text: i18n.t("Recipes.Fields.cost_unit"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "material.cost_unit",
        },
        {
          text: i18n.t("Recipes.Fields.conversion_rate"),
          align: "end",
          class: "text-no-wrap",
          sortable: false,
          value: "material.cost_unit_rate",
        },
        {
          text: i18n.t("Recipes.Fields.net_weight"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "net_weight",
        },
        {
          text: i18n.t("Recipes.Fields.gross_weight"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "gross_weight",
        },
        {
          text: i18n.t("Recipes.Fields.net_rate"),
          align: "end",
          class: "text-no-wrap",
          sortable: false,
          value: "net_rate",
          width: "90px",
        },
        {
          text: i18n.t("Recipes.Fields.ingredient_type"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "major_ingredient_flg", //1主料，2辅料
        },
        // TODO：暂时隐掉，具体逻辑还没出
        // {
        //   text: i18n.t("Recipes.Fields.count_const"),
        //   align: "center",
        //   class: "text-no-wrap",
        //   sortable: false,
        //   value: "cost_flg",
        // },
        // 隐掉，不显示
        // {
        //   text: i18n.t("Recipes.Fields.substitute_goods"),
        //   align: "center",
        //   class: "text-no-wrap",
        //   sortable: false,
        //   value: "replace_material.material_name",
        // },
      ];

      if (!this.recipe.bom_no_modify) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        });
      }

      return headers;
    },
    costCardHeader() {
      var headers = [
        {
          text: i18n.t("Recipes.Fields.recipe_code"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "food_formula.formula_code",
        },
        {
          text: i18n.t("Recipes.Fields.recipe_name"),
          align: "start",
          sortable: false,
          value: "food_formula.formula_name",
        },
        {
          text: i18n.t("Recipes.Fields.with_num"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          width: 120,
          value: "with_num",
        },
      ];

      if (!this.recipe.bom_no_modify) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        });
      }

      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "stickTableCols"]),
  },

  data: () => ({
    recipe: {},
    dishes: [],
    serverErrors: [],
    costCardInfo: [],
    editCostCardBtn: false,
    selectMaterialsDialog: false,
    materialIdsArr: [],
    addMaterials: [],
    selectReplaceMaterialDialog: false,
    selectReplaceMaterial: null,
    currentItem: null,
    foodFormulaInfo: [],
    formulaIdsArr: [],
    selectCostCardsDialog: false,
    addcostCards: [],
    costCardMaterialsDialog: false,
    currentFormulaId: null,
  }),

  methods: {
    //计算净料率
    getNetRate(material) {
      if (material) {
        material.net_rate = material.gross_weight
          ? parseFloat(material.net_weight / material.gross_weight).toFixed(2) *
            100
          : 0;
      }
    },
    submit() {
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            var cost_card_details = this.costCardInfo.map((info) => {
              return {
                material_id: info.material_id,
                net_weight: info.net_weight,
                gross_weight: info.gross_weight,
                major_ingredient_flg: info.major_ingredient_flg,
                cost_flg: info.cost_flg,
                replace_material_id: info.replace_material_id,
              };
            });
            var cost_card_formula_details = this.foodFormulaInfo.map((info) => {
              return {
                formula_id: info.formula_id,
                with_num: info.with_num,
              };
            });
            Recipes.saveSettingInfo({
              formula_id: this.recipe.id,
              other_cost: this.recipe.other_cost,
              cost_card_details: cost_card_details,
              cost_card_formula_details: cost_card_formula_details,
            }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.costCardInfo = [];
                  this.$emit("save", this.recipe);
                  this.$emit("mode", null);
                  this.$emit("input", null);
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.value && this.value.id) {
          Recipes.getSettingInfo(this.value.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.recipe = response.data.food_formula;
                this.dishes = response.data.food_formula.food_relation;
                this.costCardInfo = [];
                this.foodFormulaInfo = [];
                this.materialIdsArr = [];
                this.formulaIdsArr = [];
                this.costCardInfo =
                  response.data.food_formula.formula_cost_card.map((info) => {
                    return Object.assign({}, info, {
                      net_rate: info.gross_weight
                        ? parseFloat(
                            info.net_weight / info.gross_weight
                          ).toFixed(2) * 100
                        : 0,
                    });
                  });
                this.foodFormulaInfo =
                  response.data.food_formula.formula_cost_card_formula;
              }
            }.bind(this)
          );
        }
      },
    },
    costCardInfo: {
      handler() {
        if (this.costCardInfo.length) {
          this.costCardInfo.map((info) => {
            if (!this.materialIdsArr.includes(info.material_id)) {
              this.materialIdsArr.push(info.material_id);
            }
          });
        } else {
          this.materialIdsArr = [];
        }
      },
    },
    foodFormulaInfo: {
      handler() {
        if (this.foodFormulaInfo.length) {
          this.foodFormulaInfo.map((info) => {
            if (!this.formulaIdsArr.includes(info.formula_id)) {
              this.formulaIdsArr.push(info.formula_id);
            }
          });
        } else {
          this.formulaIdsArr = [];
        }
      },
    },
    addMaterials: {
      handler() {
        if (this.addMaterials.length) {
          this.addMaterials.map((material) => {
            if (
              !this.costCardInfo.find((info) => info.material_id == material.id)
            ) {
              this.costCardInfo.push({
                new: this.costCardInfo.length + 1,
                material_id: material.id,
                material: material,
                net_weight: 1,
                gross_weight: 1,
                net_rate: 100,
              });
            }
          });
        }
      },
    },
    addcostCards: {
      handler() {
        if (this.addcostCards.length) {
          this.addcostCards.map((costCard) => {
            if (!this.foodFormulaInfo.find((info) => info.id == costCard.id)) {
              this.foodFormulaInfo.push({
                new: this.foodFormulaInfo.length + 1,
                formula_id: costCard.id,
                food_formula: {
                  formula_code: costCard.formula_code,
                  formula_name: costCard.formula_name,
                },
                with_num: null,
              });
            }
          });
        }
      },
    },
    selectReplaceMaterialDialog: {
      handler() {
        if (this.selectReplaceMaterialDialog) {
          this.selectReplaceMaterial = null;
        }
      },
    },
    selectReplaceMaterial: {
      handler() {
        if (this.selectReplaceMaterial) {
          this.currentItem = Object.assign({}, this.currentItem, {
            replace_material: this.selectReplaceMaterial,
            replace_material_id: this.selectReplaceMaterial.id,
          });

          this.costCardInfo = this.costCardInfo.map((info) => {
            if (info.id == this.currentItem.id) {
              info = JSON.parse(JSON.stringify(this.currentItem));
            }

            return info;
          });

          this.selectReplaceMaterialDialog = false;
        }
      },
    },
  },
};
</script>